import React, { useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import { version } from 'config';
import { useTranslation } from 'react-i18next';
import DataContext from 'y4/context/DataContext';
const Footer = () => {
  const { globalData } = useContext(DataContext);
  const authentication = globalData ? globalData.authentication : null;
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <Row className="justify-content-between text-center fs--1 mt-4 mb-3">
        <Col sm="auto">
          <p
            className="mb-0 text-600"
            dangerouslySetInnerHTML={{
              __html: t('Thank you for selected AllyWorld')
            }}
          ></p>
        </Col>
        <Col sm="auto">
          <p className="mb-0 text-600">
            {authentication ? authentication.userFullName : null}
            &nbsp;&nbsp;&nbsp;&nbsp; v{version}
          </p>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
